export default function({ redirect, route }) {
  if (route.path.toLowerCase() !== route.path) {
    const redirectTo = route.fullPath.replace(route.path, route.path.toLowerCase())
    return redirect(301, redirectTo)
  }
}
